export const NAV = {
  logo: "nav-logo",
  linkFeatures: "nav-link-features",
  linkProduct: "nav-link-product",
  linkHowItWorks: "nav-link-how-it-works",
  linkFaq: "nav-link-faq",
  ctaDemo: "nav-cta-demo",
  ctaLogin: "nav-cta-login",
};

export const HERO = {
  badge: "hero-badge",
  heading: "hero-heading",
  ctaPrimary: "hero-cta-primary",
  ctaSecondary: "hero-cta-secondary",
  visual: "hero-visual",
};

export const FEATURES = {
  section: "features-section",
  cardClaims: "feature-card-claims",
  cardDenials: "feature-card-denials",
  cardAging: "feature-card-aging",
  cardMultitenant: "feature-card-multitenant",
};

export const SHOWCASE = {
  section: "product-showcase",
  tabFlow: "showcase-tab-flow",
  tabSessions: "showcase-tab-sessions",
  tabAging: "showcase-tab-aging",
  tabMonth: "showcase-tab-month",
  image: "showcase-image",
};

export const HOW = {
  section: "how-it-works-section",
};

export const STATS = {
  section: "stats-section",
};

export const FAQ = {
  section: "faq-section",
  item: (i) => `faq-item-${i}`,
};

export const CONTACT = {
  section: "contact-section",
  form: "contact-form",
  inputName: "contact-input-name",
  inputEmail: "contact-input-email",
  inputCompany: "contact-input-company",
  inputRole: "contact-input-role",
  inputMessage: "contact-input-message",
  submit: "contact-submit",
  success: "contact-success",
  error: "contact-error",
};

export const FOOTER = {
  section: "footer-section",
};
